/* ============
 * Organizations Actions
 * ============
 *
 * The actions available for the Organizations module.
 */

import store from '@/store';
import organizationApi from '@/api/OrganizationApi';
import DafApi from '@/api/DafApi';
import * as types from './mutation-types';

/**
 * Action fired when all organizations will be fetched.
 *
 * @param {function} commit Commit function to update the store.
 * @param {function} fn     Callback to edit the parameters on the api.
 */
const all = ({ commit }, fn = null) => {
  if (typeof fn === 'function') {
    fn(organizationApi);
  }
  store.dispatch('application/startLoading');
  return organizationApi.all()
    .then((response) => {
      store.dispatch('application/finishLoading');
      const data = {
        organizations: response.data,
        pagination: response.pagination,
      };

      commit(types.ALL, data);
      return data;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Erreur lors de la récupération de la liste d\'organisations',
      });
      return Promise.reject(error);
    });
};

const reset = ({ commit }) => {
  const data = {
    organizations: [],
    pagination: {
      offset: 0,
      limit: 20,
      totalCount: 0,
      totalPages: 0,
    },
  };
  commit(types.ALL, data);
};

const getDeskDafOrganizations = ({ commit }, fn = null) => {
  if (typeof fn === 'function') {
    fn(organizationApi);
  }
  store.dispatch('application/startLoading');
  return organizationApi.deskDafOrganizations()
    .then((response) => {
      store.dispatch('application/finishLoading');
      const data = {
        organizations: response.data,
        pagination: response.pagination,
      };

      commit(types.ALL, data);
      return data;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      store.dispatch('application/openSnackbar', {
        message: 'Erreur lors de la récupération de la liste d\'organisations',
      });
      return Promise.reject(error);
    });
};

/**
 * Action fired when an organization will be created.
 *
 * @param {Object}   organization   The organization that will be created.
 */
// eslint-disable-next-line
const create = ({ commit }, organization) => {
  console.log(commit);
  store.dispatch('application/startLoading');

  return organizationApi.create(organization)
    .then((response) => {
      store.dispatch('application/finishLoading');
      return response;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      return Promise.reject(error);
    });
};

const createDeskDaf = ({ commit }, organization) => {
  console.log(commit);
  store.dispatch('application/startLoading');
  return organizationApi.createDeskDafOrganization(organization)
    .then((response) => {
      store.dispatch('application/finishLoading');
      return response;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      return Promise.reject(error);
    });
};

const setCurrentPage = ({ commit }, currentPage) => {
  commit(types.SET_CURRENT_PAGE, currentPage);
};


const fetchDeskrhServices = ({ commit }, orgList) => {
  console.log(commit);
  store.dispatch('application/startLoading');
  return DafApi.fetchDeskrhServices(orgList)
    .then((response) => {
      store.dispatch('application/finishLoading');
      return response.data.data;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      return Promise.reject(error);
    });
};

const fetchDafServices = ({ commit }, orgList) => {
  console.log(commit);
  store.dispatch('application/startLoading');
  if (!process.env.DAF_ACTIVATED) {
    return new Promise((resolve) => {
      store.dispatch('application/finishLoading');
      resolve([]);
    });
  }
  return DafApi.fetchDafServices(orgList)
    .then((response) => {
      store.dispatch('application/finishLoading');
      return response.data.data;
    })
    .catch((error) => {
      store.dispatch('application/finishLoading');
      return Promise.reject(error);
    });
};

const setActiveDomain = ({ commit }, domain) => commit(types.SET_ACTIVE_DOMAIN, domain);
const resetActiveDomain = ({ commit }) => commit(types.RESET_ACTIVE_DOMAIN);

export default {
  all,
  reset,
  getDeskDafOrganizations,
  createDeskDaf,
  create,
  setCurrentPage,
  fetchDeskrhServices,
  fetchDafServices,
  setActiveDomain,
  resetActiveDomain,
};



// WEBPACK FOOTER //
// ./src/store/modules/organizations/actions.js